import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { OptionType, PromiseStatuses } from "../../../utils";
import { CertBioSuisseResponseDTO, CreateCertBioSuisseDTO, EditCertBioSuisseDTO, GetAllCertificatesFiltersDTO } from "./dataService/dto";
import { NewBioSuisseService } from "./dataService/service";
interface BioSuisseState {
    // FILTERS
    getAllCertificatesFilters: GetAllCertificatesFiltersDTO
    getAllCertificatesResponse?: CertBioSuisseResponseDTO
    createCertificate: CreateCertBioSuisseDTO
    editCertificate: EditCertBioSuisseDTO
    idSelectedCert?: string
    bioSuisseCreationStatus: PromiseStatuses
    bioSuisseGetAllStatus: PromiseStatuses
    bioSuisseUpdateStatus: PromiseStatuses
}

const initialState: BioSuisseState = {
    getAllCertificatesFilters: {
        itemsPerPage: 100,
        page: 0,
        order: true
    },
    createCertificate: {},
    editCertificate: {},
    bioSuisseCreationStatus: 'idle',
    bioSuisseGetAllStatus: 'idle',
    bioSuisseUpdateStatus: 'idle'
}

export const BioSuisseCreation = createAsyncThunk(
    'bioSuisse/BioSuisseCreation',
    async (body: CreateCertBioSuisseDTO, thunkApi): Promise<void> => {
        const bioSuisseService = NewBioSuisseService()

        return bioSuisseService.CreateBioSuisse(body).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const UpdateBioSuisse = createAsyncThunk(
    'bioSuisse/UpdateBioSuisse',
    async (request: { body: EditCertBioSuisseDTO, id: string }, thunkApi): Promise<void> => {
        const bioSuisseService = NewBioSuisseService()

        return bioSuisseService.UpdateBioSuisse(request.body, request.id).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const GetAllBioSuisse = createAsyncThunk(
    'bioSuisse/GetAllBioSuisse',
    async (filters: GetAllCertificatesFiltersDTO, thunkApi): Promise<CertBioSuisseResponseDTO> => {
        const bioSuisseService = NewBioSuisseService()

        return bioSuisseService.GetAllBioSuisse(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const BioSuisseSlice = createSlice({
    name: 'bioSuisse/slice',
    initialState,
    reducers: {
        //Create
        setCreateEntryProtocolRequest: (state, action) => {
            state.createCertificate.certificationRequestId = action.payload
        },
        setCreateResult: (state, action) => {
            state.createCertificate.result = action.payload
        },
        setCreateInspectionVisitId: (state, action) => {
            state.createCertificate.inspectionVisitId = action.payload
        },
        setCreateDepartureProtocolSend: (state, action) => {
            state.createCertificate.sendingChecklistId = action.payload
        },
        setCreateEntryProtocolResponse: (state, action) => {
            state.createCertificate.bioSuisseCertificateId = action.payload
        },
        setCreateNote: (state, action) => {
            state.createCertificate.note = action.payload
        },
        setCreateCertifiedProducts: (state, action) => {
            state.createCertificate.certificatedProducts = action.payload
        },
        setCreateCertificateDate: (state, action) => {
            state.createCertificate.validityStartingDate = action.payload
        },
        setCreateCertificateExpires: (state, action) => {
            state.createCertificate.validityEndingDate = action.payload
        },
        setCreateCondition: (state, action) => {
            state.createCertificate.certificationConditions = action.payload
        },
        setCreateNoteCondition: (state, action) => {
            state.createCertificate.certificationConditionsDetail = action.payload
        },
        setCreateCustomerId: (state, action) => {
            state.createCertificate.customerId = action.payload
        },

        //Edit

        setEditEntryProtocolRequest: (state, action) => {
            state.editCertificate.certificationRequestId = action.payload
        },
        setEditResult: (state, action) => {
            state.editCertificate.result = action.payload
        },
        setEditInspectionVisitId: (state, action) => {
            state.editCertificate.inspectionVisitId = action.payload
        },
        setEditDepartureProtocolSend: (state, action) => {
            state.editCertificate.sendingChecklistId = action.payload
        },
        setEditEntryProtocolResponse: (state, action) => {
            state.editCertificate.bioSuisseCertificateId = action.payload
        },
        setEditNote: (state, action) => {
            state.editCertificate.note = action.payload
        },
        setEditCertifiedProducts: (state, action) => {
            state.editCertificate.certificatedProducts = action.payload
        },
        setEditCertificateDate: (state, action) => {
            state.editCertificate.validityStartingDate = action.payload
        },
        setEditCertificateExpires: (state, action) => {
            state.editCertificate.validityEndingDate = action.payload
        },
        setEditCondition: (state, action) => {
            state.editCertificate.condition = action.payload
        },
        setEditNoteCondition: (state, action) => {
            state.editCertificate.certificationConditionsDetail = action.payload
        },
        setEditIdSelectedCert: (state, action) => {
            state.idSelectedCert = action.payload
        },


        //Reset
        resetGetAllCertificatesFilters: (state) => {
            state.getAllCertificatesFilters = {
                itemsPerPage: 100,
                page: 0,
                order: true
            }
        },
        resetCreateRequest: (state) => {
            state.createCertificate = {}
        },
        resetEditRequest: (state) => {
            state.editCertificate = {}
        },
        resetCreateStatus: (state) => {
            state.bioSuisseCreationStatus = 'idle'
        },
        resetUpdateStatus: (state) => {
            state.bioSuisseUpdateStatus = 'idle'
        },
        resetGetAllStatus: (state) => {
            state.bioSuisseGetAllStatus = 'idle'
        },
        //filters

    },
    extraReducers(builder) {
        builder
            //CREATE
            .addCase(BioSuisseCreation.pending, (state) => {
                state.bioSuisseCreationStatus = 'loading'
            })
            .addCase(BioSuisseCreation.fulfilled, (state, action) => {
                state.bioSuisseCreationStatus = 'successfully'
            })
            .addCase(BioSuisseCreation.rejected, (state) => {
                state.bioSuisseCreationStatus = 'failed'
            })
            //GET ALL
            .addCase(GetAllBioSuisse.pending, (state) => {
                state.bioSuisseGetAllStatus = 'loading'
            })
            .addCase(GetAllBioSuisse.fulfilled, (state, action) => {
                state.bioSuisseGetAllStatus = 'successfully'
                state.getAllCertificatesResponse = action.payload
            })
            .addCase(GetAllBioSuisse.rejected, (state) => {
                state.bioSuisseGetAllStatus = 'failed'
            })
            //UPDATE
            .addCase(UpdateBioSuisse.pending, (state) => {
                state.bioSuisseUpdateStatus = 'loading'
            })
            .addCase(UpdateBioSuisse.fulfilled, (state, action) => {
                state.bioSuisseUpdateStatus = 'successfully'
            })
            .addCase(UpdateBioSuisse.rejected, (state) => {
                state.bioSuisseUpdateStatus = 'failed'
            })
    }
})

export const {
    setCreateCertificateDate,
    setCreateCertificateExpires,
    setCreateCertifiedProducts,
    setCreateCondition,
    setCreateDepartureProtocolSend,
    setCreateEntryProtocolRequest,
    setCreateEntryProtocolResponse,
    setCreateInspectionVisitId,
    setCreateNote,
    setCreateResult,
    setEditCertificateDate,
    setEditCertificateExpires,
    setEditCertifiedProducts,
    setEditCondition,
    setEditDepartureProtocolSend,
    setEditEntryProtocolRequest,
    setEditEntryProtocolResponse,
    setEditInspectionVisitId,
    setEditNote,
    setEditResult,
    setEditNoteCondition,
    setCreateNoteCondition,
    setEditIdSelectedCert,
    resetCreateRequest,
    resetEditRequest,
    resetGetAllCertificatesFilters,
    resetCreateStatus,
    resetGetAllStatus,
    resetUpdateStatus,
    setCreateCustomerId
} = BioSuisseSlice.actions

export default BioSuisseSlice.reducer